import DescriptionText from "./DescriptionText"

export default DescriptionText
